module.exports = __webpack_public_path__ + "static/media/magnifier.61e912b3.svg";